import { CURRENCIES_SIGNS } from 'utils/constants';
import { ICurrencyFormat } from 'utils/types';
import numeral from 'numeral';

const COLUMN_WIDTH = 130;

const getHeadcountColumn = () => ({
  headerName: 'Headcount',
  field: 'headcount',
  type: 'numericColumn',
  minWidth: COLUMN_WIDTH,
  sortable: true,
});

const getSpendColumn = (format: ICurrencyFormat) => ({
  headerName: 'Total cost',
  field: 'spend',
  type: 'numericColumn',
  minWidth: COLUMN_WIDTH,
  sortable: true,
  valueFormatter: (params: any) =>
    `${CURRENCIES_SIGNS[format.currency]}${numeral(params.value).format(
      '0,0.[0]'
    )}`,
});

export const useTableData = (format: ICurrencyFormat, isHeadcount: boolean) => {
  const valueColumn = isHeadcount
    ? getHeadcountColumn()
    : getSpendColumn(format);
  return [
    {
      headerName: 'Application Name',
      field: 'applicationName',
      minWidth: 280,
      sortable: true,
    },
    {
      headerName: 'App Type',
      field: 'applicationType',
      minWidth: COLUMN_WIDTH,
      sortable: true,
    },
    valueColumn,
    {
      headerName: 'Business owner',
      field: 'businessOwner',
      minWidth: COLUMN_WIDTH,
      sortable: true,
    },
    {
      headerName: 'FTE',
      field: 'fte',
      type: 'numericColumn',
      minWidth: COLUMN_WIDTH,
      sortable: true,
    },
  ];
};
